const components = [
  {
    num: '1',
    title: 'Цель развития',
    desc: 'Что сотрудник должен уметь или делать лучше.',
  },
  {
    num: '2',
    title: 'Компетенция',
    desc: 'Какая конкретная компетенция требует развития.',
  },
  {
    num: '3',
    title: 'Текущий уровень',
    desc: 'Что сотрудник уже умеет и какие есть дефициты.',
  },
  {
    num: '4',
    title: 'Желаемый уровень',
    desc: 'Какой уровень необходим для эффективного выполнения текущей или будущей роли.',
  },
  {
    num: '5',
    title: 'Действия',
    desc: 'Какие конкретные действия должен выполнить сотрудник.',
  },
  {
    num: '6',
    title: 'Инструменты развития',
    desc: 'Обучение, наставничество, практика, проекты, коучинг, самостоятельная работа и другие инструменты.',
  },
  {
    num: '7',
    title: 'Срок',
    desc: 'Когда необходимо достичь результата.',
  },
  {
    num: '8',
    title: 'Ответственные',
    desc: 'Кто участвует в развитии: сотрудник, руководитель, наставник, HR, тренер.',
  },
  {
    num: '9',
    title: 'Критерии результата',
    desc: 'Как понять, что компетенция действительно развилась.',
  },
];

export default function IPRComponents() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Из чего состоит ИПР
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Основные элементы индивидуального плана развития
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {components.map((c) => (
            <div key={c.num} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors">
              <div className="w-10 h-10 bg-teal-600 text-white rounded-lg flex items-center justify-center font-bold text-lg mb-4">
                {c.num}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{c.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}